export default __webpack_public_path__ + "static/media/lpimage.7c8aaed5.svg";